import { Component, OnInit } from '@angular/core';
declare var zE: any;

@Component({
  selector: 'bxl-hof-inductees',
  templateUrl: 'hof-inductees.component.html',
})
export class HofInducteesComponent implements OnInit {
  initialized = false;
  constructor() { }

  ngOnInit(): void {
    this.initialized = true;
    zE('webWidget', 'hide');
    zE('webWidget:on', 'close', () => {
      zE('webWidget', 'hide');
    });

    zE('webWidget:on', 'chat:unreadMessages', () => {
      zE('webWidget', 'show');
      zE('webWidget', 'open');
    });
  }
}
